<template>
  <div class="row">
    <div class="col-md-12">
      <dashboard-box :back="true" back-component-name="store.materials">
        <template v-slot:title>
          <span>{{ $t("materials.users") }}</span>
        </template>
        <template v-slot:preview>
          <b-row>
            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('materials.supplier_company')">
                <multiple-select-input
                    v-if="supplierCompanies"
                    :model.sync="form.supplier_company_id"
                    :multiple="false"
                    :values="supplierCompanies"
                    label="name"
                    track-by="id"
                ></multiple-select-input>
                <b-form-invalid-feedback
                    v-if="!validateState('supplier_company_id') && !$v.form.supplier_company_id.required"
                    :state="true">
                  {{ $t('materials.validations.supplier_company.required') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('materials.brand')">
                <multiple-select-input
                    v-if="brands"
                    :model.sync="form.brand_id"
                    :multiple="false"
                    :values="brands"
                    label="name"
                    track-by="id"
                ></multiple-select-input>
                <b-form-invalid-feedback
                    v-if="!validateState('brand_id') && !$v.form.brand_id.required"
                    :state="true">
                  {{ $t('materials.validations.brand.required') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('materials.brand')">
                <multiple-select-input
                    v-if="materialModels"
                    :model.sync="form.material_model_id"
                    :multiple="false"
                    :values="materialModels"
                    label="name"
                    track-by="id"
                ></multiple-select-input>
                <b-form-invalid-feedback
                    v-if="!validateState('material_model_id') && !$v.form.material_model_id.required"
                    :state="true">
                  {{ $t('materials.validations.material_model.required') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('materials.name')">
                <b-form-input
                    v-model="form.name"
                    :placeholder="$t('materials.name')"
                    :state="validateState('name')"
                    class="form-control form-control-solid"
                    name="name"
                    type="text"
                ></b-form-input>
                <b-form-invalid-feedback
                    v-if="!validateState('name') && !$v.form.name.required"
                    :state="!(validateState('name') && !$v.form.name.required)">
                  {{ $t('materials.validations.name.required') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('materials.description')">
                <b-form-input
                    v-model="form.description"
                    :placeholder="$t('materials.description')"
                    :state="validateState('description')"
                    class="form-control form-control-solid"
                    name="description"
                    type="text"
                ></b-form-input>
                <b-form-invalid-feedback
                    v-if="!validateState('description') && !$v.form.description.required"
                    :state="!(validateState('description') && !$v.form.description.required)">
                  {{ $t('materials.validations.description.required') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('materials.stock_code')">
                <b-form-input
                    v-model="form.stock_code"
                    :placeholder="$t('materials.stock_code')"
                    :state="validateState('stock_code')"
                    class="form-control form-control-solid"
                    name="stock_code"
                    type="text"
                ></b-form-input>
                <b-form-invalid-feedback
                    v-if="!validateState('stock_code') && !$v.form.stock_code.required"
                    :state="!(validateState('stock_code') && !$v.form.stock_code.required)">
                  {{ $t('materials.validations.stock_code.required') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('materials.amount')">
                <b-form-input
                    v-model="form.amount"
                    :placeholder="$t('materials.amount')"
                    :state="validateState('amount')"
                    class="form-control form-control-solid"
                    name="amount"
                    type="number"
                ></b-form-input>
                <b-form-invalid-feedback
                    v-if="!validateState('amount') && !$v.form.amount.required"
                    :state="!(validateState('amount') && !$v.form.amount.required)">
                  {{ $t('materials.validations.stock_code.required') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>


            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('materials.unit')">
                <multiple-select-input
                    v-if="units"
                    :model.sync="form.unit_id"
                    :multiple="false"
                    :values="units"
                    label="code"
                    track-by="id"
                ></multiple-select-input>
                <b-form-invalid-feedback
                    v-if="!validateState('unit_id') && !$v.form.unit_id.required"
                    :state="true">
                  {{ $t('materials.validations.unit.required') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col lg="6" md="6" sm="12" xl="6">

                 <div class="form-group">
                  <label>{{ $t('materials.image') }} </label>
                  <div class="custom-file">
                    <input type="file"
                           accept="image/*"
                           ref="material-image"
                           @change="uploadFile($event)"
                           :placeholder="$t('general.select')"
                           class="custom-file-input" id="inputGroupFile02">
                    <label class="custom-file-label" for="inputGroupFile02">{{ $t('general.select_option')}}</label>
                  </div>
                </div>
            </b-col>

            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('team_types.status')">
                <b-form-checkbox v-model="form.status" name="check-button" switch>
                </b-form-checkbox>
              </b-form-group>
            </b-col>

            <template v-if="form.id && form.exits_file">
              <b-col lg="3" md="3" sm="12" xl="3">
                <img :src="form.exits_file" class="img-fluid img-thumbnail">
                <div class="text-center">
                  <b-btn class="mt-2" size="xs" variant="danger" @click="deleteFile()"><i class="fa fa-trash"></i>
                  </b-btn>
                </div>
              </b-col>
            </template>

            <b-col
                class="float-right text-right"
                lg="12"
                md="12"
                sm="12"
                xl="12"
            >
              <b-button
                  class="mr-1"
                  variant="secondary"
                  @click="goBack"
              >
                <i class="fas fa-arrow-left"></i>
                {{ $t("general.cancel") }}
              </b-button>
              <b-button variant="primary" @click="createOrUpdate()">
                <i class="far fa-save"></i>
                {{ $t(id != null ? "general.save" : "general.create") }}
              </b-button>
            </b-col>
          </b-row>
        </template>
      </dashboard-box>
    </div>
  </div>
</template>
<script>
import DashboardBox from "@/assets/components/DashboardBox";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";

import baseModule, {
  BASE_URL,
  CREATE_ITEM,
  DELETE_FILE,
  ERROR,
  FILES,
  GET_FILES,
  GET_ITEM,
  ITEM,
  LOADING,
  MODULE_NAME,
  SUCCESS,
  UPDATE_ITEM,
  UPLOAD_FILE
} from "@/core/services/store/material.module";

import unitModule, {
  GET_ALL_ITEMS as GET_UNIT_ITEMS,
  ITEMS_ALL as UNIT_ITEMS,
  MODULE_NAME as UNIT_MODULE
} from "@/core/services/store/unit.module";

import supplierCompanyModule, {
  GET_ALL_ITEMS as GET_SUPPLIER_COMPANY_ITEMS,
  ITEMS_ALL as SUPPLIER_COMPANY_ITEMS,
  MODULE_NAME as SUPPLIER_COMPANY_MODULE
} from "@/core/services/store/supplierCompany.module";

import materialModelModule, {
  GET_ALL_ITEMS as GET_MATERIAL_MODEL_ITEMS,
  ITEMS_ALL as MATERIAL_MODEL_ITEMS,
  MODULE_NAME as MATERIAL_MODEL_MODULE
} from "@/core/services/store/materialModel.module";

import brandModule, {
  GET_ALL_ITEMS as GET_BRAND_ITEMS,
  ITEMS_ALL as BRAND_ITEMS,
  MODULE_NAME as BRAND_MODULE
} from "@/core/services/store/brand.module";

import store from "@/core/services/store";
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";
import MultipleSelectInput from "@/assets/components/inputs/MultipleSelectInput";
import _ from "lodash";

const _MODULE_NAME = MODULE_NAME;
const _UNIT_MODULE = UNIT_MODULE;
const _BRAND_MODULE = BRAND_MODULE;
const _SUPPLIER_COMPANY_MODULE = SUPPLIER_COMPANY_MODULE;
const _MATERIAL_MODEL_MODULE = MATERIAL_MODEL_MODULE;

export default {
  name: "MaterialsCreateEdit",
  mixins: [validationMixin],
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_MODULE_NAME, baseModule);
    registerStoreModule(_UNIT_MODULE, unitModule);
    registerStoreModule(_BRAND_MODULE, brandModule);
    registerStoreModule(_SUPPLIER_COMPANY_MODULE, supplierCompanyModule);
    registerStoreModule(_MATERIAL_MODEL_MODULE, materialModelModule);
  },
  components: {
    DashboardBox,
    MultipleSelectInput
  },
  validations: {
    form: {
      name: {
        required
      },
      description: {
        required
      },
      stock_code: {
        required
      },
      amount: {
        required
      },
      unit_id: {
        required
      },
      supplier_company_id: {
        required
      },
      brand_id: {
        required
      },
      material_model_id: {
        required
      }
    }
  },
  computed: {
    isAuthorizedToEdit() {
      return (this.isSuperAdmin || this.isOperator)
    },
    error() {
      return store.getters[_MODULE_NAME + "/" + ERROR];
    },
    loading() {
      return store.getters[_MODULE_NAME + "/" + LOADING];
    },
    success() {
      return store.getters[_MODULE_NAME + "/" + SUCCESS];
    },
    item() {
      return store.getters[_MODULE_NAME + "/" + ITEM];
    },
    files() {
      return store.getters[_MODULE_NAME + "/" + FILES];
    },
    units() {
      return store.getters[_UNIT_MODULE + "/" + UNIT_ITEMS] || [];
    },
    supplierCompanies() {
      return store.getters[_SUPPLIER_COMPANY_MODULE + "/" + SUPPLIER_COMPANY_ITEMS] || [];
    },
    brands() {
      return store.getters[_BRAND_MODULE + "/" + BRAND_ITEMS] || [];
    },
    materialModels() {
      return store.getters[_MATERIAL_MODEL_MODULE + "/" + MATERIAL_MODEL_ITEMS] || [];
    }
  },
  data() {
    return {
      id: this.$route.params.id,
      form: {
        name: null,
        description: null,
        stock_code: null,
        unit_id: null,
        supplier_company_id: null,
        brand_id: null,
        material_model_id: null,
        amount: null,
        status: true
      }
    };
  },
  methods: {
    uploadFile(e) {
      let file = e.target.files[0];
      this.form.file = file;
      if (this.id && file) {
        let self = this;
        let form = new FormData();
        form.append('file', file);
        let url = BASE_URL + '/' + this.id + '/file';
        this.$store
            .dispatch(_MODULE_NAME + "/" + UPLOAD_FILE, {
              url: url,
              contents: form,
            }).then((response) => {
          if (response.status) {
            setTimeout(() => {
              self.sweetAlertSuccess(response.data.message).then(() => {
                self.$store.dispatch(_MODULE_NAME + "/" + GET_FILES, {
                  url: url
                })
              }) ;
            }, 200);
          }
        });
      }
    },
    deleteFile() {
      let self = this;
      this.sweetAlertConfirm(
          this.$t("general.are_you_sure"),
          function (self) {
            let url = BASE_URL + "/" + self.id + '/file'
            self.$store
                .dispatch(_MODULE_NAME + "/" + DELETE_FILE, {
                  url: url
                }).then(response => {
              if (response.status) {
                self.form.exits_file = null;
                setTimeout(() => {
                  self.sweetAlertSuccess(response.data.message).then(() => {
                    self.$store.dispatch(_MODULE_NAME + "/" + GET_FILES, {
                      url: url
                    })
                  }) ;
                }, 100);
              }
            })
          });
    },
    goBack() {
      this.$router.push({name: "store.materials"})
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    getItem() {
      this.$store
          .dispatch(_MODULE_NAME + "/" + GET_ITEM, {
            url: BASE_URL + "/" + this.id,
          })
    },
    getUnits() {
        this.$store
            .dispatch(_UNIT_MODULE + "/" + GET_UNIT_ITEMS, {})
    },
    getBrands() {
        this.$store
            .dispatch(_BRAND_MODULE + "/" + GET_BRAND_ITEMS, {})
    },
    getMaterialModels() {
        this.$store
            .dispatch(_MATERIAL_MODEL_MODULE + "/" + GET_MATERIAL_MODEL_ITEMS, {})
    },
    getSupplierCompanies() {
        this.$store
            .dispatch(_SUPPLIER_COMPANY_MODULE + "/" + GET_SUPPLIER_COMPANY_ITEMS, {})
    },
    createOrUpdate() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      if (this.id) {
        let formData = _.clone(this.form);
        formData.unit_id = formData.unit_id.id;
        formData.supplier_company_id = formData.supplier_company_id.id;
        formData.brand_id = formData.brand_id.id;
        formData.material_model_id = formData.material_model_id.id;

        if (this.form.status) {
          formData.status = 1;
        } else {
          formData.status = 0;
        }

        this.$store
            .dispatch(_MODULE_NAME + "/" + UPDATE_ITEM, {
              url: BASE_URL + "/" + this.id,
              contents: formData
            });
      } else {
        let form = new FormData();
        form.append('name', this.form.name);
        form.append('description', this.form.description);
        form.append('stock_code', this.form.stock_code);
        form.append('amount', this.form.amount);
        form.append('unit_id', this.form.unit_id.id);
        form.append('supplier_company_id', this.form.supplier_company_id.id);
        form.append('brand_id', this.form.brand_id.id);
        form.append('material_model_id', this.form.material_model_id.id);

        if (this.form.status) {
          form.append('status', 1);
        } else {
          form.append('status', 0);
        }

        if(this.form.image) {
          form.append('file', this.form.image);
        }

        this.$store
            .dispatch(_MODULE_NAME + "/" + CREATE_ITEM, {
              url: BASE_URL,
              contents: form,
            });
      }
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {title: this.$t("general.dashboard"), route: "dashboard"},
      {title: this.$t(this.id ? "materials.edit_item" : "materials.create_item")}
    ]);

    if (this.units && !this.units.length) {
      this.getUnits();
    }

    if (this.supplierCompanies && !this.supplierCompanies.length) {
      this.getSupplierCompanies();
    }

    if (this.brands && !this.brands.length) {
      this.getBrands();
    }

    if (this.materialModels && !this.materialModels.length) {
      this.getMaterialModels();
    }

    if (this.id) {
      this.getItem();
    }
  },
  watch: {
    files: {
      handler: function (newVal, oldVal) {
        if (newVal) {
          this.form.exits_file = null;
          this.form.exits_file = newVal;
          this.form.image = null;
        }
      },
      deep: true
    },
    item(value) {
      if (value) {
        let item = value.item;
        if (item.status) {
          item.status = true;
        } else {
          item.status = false;
        }

        if (item.unit_id && typeof item.unit_id !== 'object') {
          item.unit_id = item.unit;
        }

        if (item.supplier_company_id && typeof item.supplier_company_id !== 'object') {
          item.supplier_company_id = item.supplier_company;
        }

        if (item.brand_id && typeof item.brand_id !== 'object') {
          item.brand_id = item.brand;
        }

        if (item.material_model_id && typeof item.brand_id !== 'object') {
          item.material_model_id = item.material_model;
        }

        if (item.image_link) {
          item.image = null;
          item.exits_file = item.image_link;
        }

        this.form = item;
      }
    },
    success(value) {
      let self = this;
      if (value) {
        setTimeout(() => {
          self.sweetAlertSuccess(self.$t("general.successfully_saved"),
              (response) => {
                if (response) {
                  self.$router.push({name: "store.materials"});
                }
              });
        }, 500)
      }
    }
  }
};
</script>

<style scoped>
#dashboard-box {
  padding: 10px;
}
</style>
